import React, { useEffect, useState } from 'react'
import { Trophy, BookOpen } from 'lucide-react'
import { HeroBanner } from './ui/HeroBanner'
import { AvailableCourses } from './ui/AvailableCourses'
import { useUser } from '../context/UserContext'
import { useBreadcrumbs } from '@renderer/context/BreadcrumbContext'

const CoursesProgressCard = ({ progressPct }: { progressPct: number }): React.JSX.Element => (
  <div
    className="flex flex-col gap-3 px-8 py-6"
    style={{
      background: '#f5ede0',
      borderRadius: '16px',
      border: '1px solid #e0d4be',
      minWidth: '220px'
    }}
  >
    <Trophy className="w-6 h-6 text-[#7a6020]" />
    <div>
      <p className="text-sm text-gray-500 font-medium">Overall Progress</p>
      <div className="flex items-baseline gap-2">
        <p className="text-3xl font-bold text-gray-900">{progressPct}%</p>
      </div>
    </div>
    <div style={{ width: '100%', height: '6px', background: '#e0d4be', borderRadius: '3px' }}>
      <div style={{ width: `${progressPct}%`, height: '100%', background: '#7a6020', borderRadius: '3px' }} />
    </div>
  </div>
)

export const MainPage = (): React.JSX.Element => {
  const { user } = useUser()
  const { setBreadcrumbs } = useBreadcrumbs()
  const [overallProgress, setOverallProgress] = useState(0)

  useEffect(() => {
    setBreadcrumbs([{ label: 'Courses' }])
  }, [])

  const getFirstName = () => {
    if (!user?.email) return 'User'
    const name = user.email.split('@')[0]
    return name.charAt(0).toUpperCase() + name.slice(1)
  }

  return (
    <div>
      <div className="max-w-[1200px] mx-auto space-y-6">
        <HeroBanner
          tag={
            <>
              <BookOpen className="w-3.5 h-3.5" />
              Courses
            </>
          }
          title={`Welcome back, ${getFirstName()}`}
          // description="Your course is in progress and you have spent 10 hrs till now this month."
          description={`Your course is ${overallProgress}% complete. Keep going!`}
          rightContent={<CoursesProgressCard progressPct={overallProgress} />}
        />
        <AvailableCourses onProgressCalculated={setOverallProgress} />
      </div>
    </div>
  )
}